import { useEditor } from 'client/widget-components';
import React from 'react';
import { useBookingContext } from '../../../Context';
import { Booking, BookingStatus } from '../../../types';
import BookingConfirmation from './BookingConfirmation';
import BookingConfirmationDryRun from './BookingConfirmationDryRun';
import BookingConfirmationPending from './BookingConfirmationPending';
import BookingPreviewConfirmation from './BookingConfirmationPreview';

interface BookingConfirmContainerProps {
    confirmationData: Booking;
    closeConfirmation: () => void;
    rescheduleBooking: () => void;
    setCancelBookingId: (bookingId: string) => void;
}

const BookingConfirmContainer = (props: BookingConfirmContainerProps) => {
    const { closeConfirmation, confirmationData } = props;

    const { isBookingDryRun } = useBookingContext();
    const editor = useEditor();

    const showPreviewConfirmation = editor.isInPreviewOrEditor();
    const showDryRunConfirmation = confirmationData && isBookingDryRun;
    const showConfirmation =
        confirmationData &&
        !isBookingDryRun &&
        confirmationData?.status === BookingStatus.ACCEPTED;
    const showPendingConfirmation =
        confirmationData &&
        !isBookingDryRun &&
        confirmationData?.status === BookingStatus.PENDING;

    if (showConfirmation) {
        return <BookingConfirmation {...props} />;
    }

    if (showPendingConfirmation) {
        return <BookingConfirmationPending {...props} />;
    }

    if (showPreviewConfirmation) {
        return (
            <BookingPreviewConfirmation closeConfirmation={closeConfirmation} />
        );
    }

    if (showDryRunConfirmation) {
        return (
            <BookingConfirmationDryRun closeConfirmation={closeConfirmation} />
        );
    }

    return null;
};

export default BookingConfirmContainer;
